// Environment Configuration
export const config = {
  // API Configuration
  API_BASE_URL:
    process.env.REACT_APP_API_BASE_URL || 'https://dev-api.jumppapp.in/api/v1',
  MEDIA_API_BASE_URL:
    process.env.REACT_APP_MEDIA_API_BASE_URL ||
    'https://upload.dev.jumppapp.in',

  // Environment
  ENV: process.env.REACT_APP_ENV || 'development',

  // App Configuration
  APP_NAME: process.env.REACT_APP_APP_NAME || 'Jumpp Admin Tool',

  // API Headers
  DEFAULT_HEADERS: {
    'Content-Type': 'application/json',
    accept: 'application/json',
    'Accept-Language': 'en-GB,en-US;q=0.9,en;q=0.8',
  },

  // Local Storage Keys
  STORAGE_KEYS: {
    AUTH_TOKEN: 'auth_token',
    USER_DATA: 'user_data',
  },
} as const;

// Type for the config object
export type Config = typeof config;
